import { memo } from 'react';

import { ReactComponent as PositionDownIcon } from '~/assets/images/collections/arrow-down-circle.svg';
import { ReactComponent as PositionUpIcon } from '~/assets/images/collections/arrow-up-circle.svg';
import { ReactComponent as PositionNoChangeIcon } from '~/assets/images/collections/dash-circle.svg';

function PositionChangeIcon({
  placement,
  previousPlacement,
  className,
}: {
  placement: number;
  previousPlacement: number;
  className: string;
}): JSX.Element {
  if (placement === previousPlacement) {
    return <PositionNoChangeIcon className={className} />;
  }
  if (placement > previousPlacement) {
    return <PositionDownIcon className={className} />;
  }
  return <PositionUpIcon className={className} />;
}

export default memo(PositionChangeIcon);
